import { lazy } from "react";

export const PdfMeTemplateDialog = lazy(() => import("./PdfMeTemplateDialog_"));
